import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js/mobile';

export default class mobileValidator {
    validate(value, country) {
        const countryUppercase = country.toUpperCase();
        const valid = isValidPhoneNumber(value, countryUppercase);

        if (!valid) return false;

        const phoneNumber = parsePhoneNumber(value, countryUppercase);

        return phoneNumber.country === countryUppercase;
    }
}
